<template>
  <div class="answer" @click="pushAnswer">
    {{answer.label}}
  </div>
</template>

<script>
export default {
  props: {
    question: {
      type: Object
    },
    answer: {
      type: Object
    }
  },
  methods: {
    pushAnswer () {
      this.$store.dispatch('pushAnswer', {
        question: this.question,
        answer: this.answer
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.answer {
  padding: 28px;
  background: white;
  box-shadow: 0 1px 6px rgba(80, 179, 237, 0.2);
  margin: 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: .2s;

  &:hover {
    transform: scale(1.01);
    box-shadow: 0px 1px 9px rgba(80, 179, 237, 0.4);
    transition: .3s;
  }
}
</style>
